
<template>
    <div :class="`list-item ${ hasBottomLine ? 'border-bottom-line' : ''}`" @click="handleClick">
        <p class="list-item-label">{{title}}</p>
        <div v-if="!$slots.msg" class="list-item-value">{{msg}}</div>
        <div v-else class="list-item-value"><slot name="msg"></slot></div>
        <i v-if="hasArrow" class="arrow-right">
            <svg-icon class="arrow-icon" icon-class="vertical-arrow" />
        </i>
    </div>
</template>

<script>
export default {
    name: "ListItem",
    props: {
        title: {
            type: String
        },
        msg: {
            type: String,
            default: ""
        },
        hasArrow: {
            type: Boolean,
            default: true
        },
        hasBottomLine: {
            type: Boolean,
            default: false
        },

        to: {}
    },
    methods: {
        handleClick() {
            if (this.to) {
                this.$router.push(this.to);
            } else {
                this.$emit("click");
            }
        }
    }
};
</script>

<style lang="scss" scoped>
@import "../../style/function.scss";
@import "../../style/config.scss";

.list-item {
    height: 1.1rem;
    background: #fff;
    position: relative;
    font-size: 0.28rem;
    display: flex;
    align-items: center;
    box-sizing: border-box;
    width: 100%;
}

.list-item-label {
    padding-left: 0.34rem;
    color: $baseColor;
}

.list-item-value {
    flex: 1;
    text-align: right;
    padding-right: 0.5rem;
    color: #999;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}

.top-split-line {
    margin-top: 0.2rem;
}

.no-bottom-line {
    border-bottom: none;
}

.arrow-right {
    position: absolute;
    right: 0.2rem;
    top: 50%;
    transform: translateY(-50%);
    font-size: 0.28rem;
    color: #979797;
}

.arrow-icon {
    transform: rotate(180deg);
}
</style>
